export default global.config = {
    i18n: {
        menu: {
            products: {
                en: "Products",
                fr: "Produits"
                },
            champions: {
                en: "Champions",
                fr: "Champions"
            },
            stallions:{
                en: "Stallion",
                fr: "Etalons"
            }
        }
        // rest of your translation object
    }
    // other global config variables you wish
};